(function () {
  $(document).ready(() => {});
})();
